import { createContext } from 'utils/react-helpers';

const [RouteProvider, useRoute] = createContext({ name: 'RouteContext' });

export { RouteProvider, useRoute };
